<template>
  <AppYearPicker
    v-model="year"
    :start-year="startYear"
  />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['minDate']),
    startYear() {
      return moment(this.minDate).year();
    },
    year: {
      get() {
        return this.$store.state.report_query.filters.year;
      },
      set(year) {
        this.$store.dispatch('updateSearch', { year });
      },
    },
  },
};
</script>
